import React from 'react';
import { hot } from 'react-hot-loader';
import { Provider } from 'react-redux';
import { BrowserRouter } from 'react-router-dom';
import UserProvider from './modules/User';
import store from './store/configureStore';
import Layout from './pages/Layout';
import MenuProvider from './modules/Menu';
import '../css/style.scss';

const App = () => (
  <UserProvider>
    <MenuProvider>
      <Provider store={store}>
        <BrowserRouter>
          <Layout />
        </BrowserRouter>
      </Provider>
    </MenuProvider>
  </UserProvider>
);

export default process.env.NODE_ENV === 'development' ? hot(module)(App) : App;
